/**
 * Copyright 2021-2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { DetailAccordionCard } from '@umati/dashboard-common';
import { Section } from '@umati/dashboard-types';
import React, { Component } from 'react';
import TemplateHelper from '../../../utilities/TemplateHelper';
import SectionRowContent from './SectionRowContent';

export interface SectionAccordionCardProps {
  eventKey: string;
  title: string;
  section: Section;
  data: any;
  isExpanded?: boolean;
  sectionIndex: number;
  sectionDataIndex: number;
}

export interface SectionAccordionCardState {
  expanded: boolean;
}

export default class SectionAccordionCard extends Component<SectionAccordionCardProps, SectionAccordionCardState> {
  constructor(props: SectionAccordionCardProps) {
    super(props);
    this.state = {
      expanded: !!props.isExpanded,
    };
  }

  render() {
    if (!TemplateHelper.checkRenderingCondition(this.props.data, this.props.section.condition)) {
      return <></>;
    }

    const colStyle = 'col-12 col-sm-6 col-md-4';

    return (
      <DetailAccordionCard eventKey={this.props.eventKey} title={this.props.title} isExpanded={this.state.expanded}>
        {this.props.section.rows.map((row, rowIndex) => (
          <>
            {!row.isPlaceholder && (
              <SectionRowContent
                key={TemplateHelper.getKeyRow(this.props.sectionIndex, this.props.sectionDataIndex, rowIndex)}
                row={row}
                cols={colStyle}
                data={this.props.data}
                sectionIndex={this.props.sectionIndex}
                sectionDataIndex={this.props.sectionDataIndex}
                rowIndex={rowIndex}
                rowDataIndex={0}
                title={row.title}
              />
            )}
            {row.isPlaceholder && (
              <>
                {TemplateHelper.getPlaceholderObjects(
                  this.props.data,
                  row.placeholderObject,
                  row.placeholderConditionType,
                ).map((innerData, innerDataIndex) => (
                  <SectionRowContent
                    key={TemplateHelper.getKeyRow(
                      this.props.sectionIndex,
                      this.props.sectionDataIndex,
                      rowIndex,
                      innerDataIndex,
                    )}
                    row={row}
                    cols={colStyle}
                    data={innerData}
                    sectionIndex={this.props.sectionIndex}
                    sectionDataIndex={this.props.sectionDataIndex}
                    rowIndex={rowIndex}
                    rowDataIndex={innerDataIndex}
                    title={
                      row.titleVariable ? TemplateHelper.getVariableValue(innerData, row.titleVariable) : undefined
                    }
                  />
                ))}
              </>
            )}
          </>
        ))}
      </DetailAccordionCard>
    );
  }
}
